// IE 2026 10 03 / ODOO-345045 (заказ Игоря: язык — профиль перечитывать, сохранение языка не молчит)
// Слова Игоря: «когда мы меняем язык, то если открыта карточка "My profile" — то желательно и в ней реактивно менять язык или лучше обновлять ее перечитывая.
// ... я ожидаю что язык берется при перезагрузке из пользователя, а не из куки».
// Что было. store.set_language (меню пользователя) слал user_settings_save «выстрелил и забыл» с пустым колбэком: открытая форма «My profile» (запись USER) показывала
// прежний язык, а ошибка сохранения (у арендатора нет локальной записи USER, роль «только чтение», сбой сети) терялась — страница держала язык в localStorage
// до перезагрузки, после неё язык брался с сервера (adoptServerLanguage) и «откатывался». Что стало.
//   fe.i18n.profileFollowsLanguage (по умолчанию вкл.): после УДАЧНОГО ответа каждая открытая форма записи USER текущего пользователя перечитывается с сервера
//     переоткрывается (закрыть жёстко + widget_open тем же вызовом, что пункт меню «My profile»; reload / select ломают форму — см. langProfile_reopen) — поле «Language» показывает новое значение. Нет такой формы — ничего.
//   fe.i18n.saveLanguageWarn (по умолчанию вкл.): ответ-ошибка или ответ без status 'ok' — уведомление «Language not saved to your profile: <причина>. It will reset on
//     the next reload.»; роль «только чтение» (вызова нет) — «Language not saved: read-only user. It will reset on the next reload.». Язык в памяти остаётся новым.
// Порядок переключения не меняется: колбэк срабатывает позже ответа, до relocalize ничего не ждётся.
import { t } from '@/i18n'

export const FLAG_REFRESH = 'fe.i18n.profileFollowsLanguage'
export const FLAG_WARN = 'fe.i18n.saveLanguageWarn'

export function langProfile_refreshOn(store) {
    try { return !!store && store.setting(FLAG_REFRESH, true) !== false } catch (e) { return false }
}
export function langProfile_warnOn(store) {
    try { return !!store && store.setting(FLAG_WARN, true) !== false } catch (e) { return false }
}

// открытые формы «My profile» ТЕКУЩЕГО пользователя (запись сегмента USER с id пользователя); скрытые мягко / закрытые и без компонента — не трогаем
export function langProfile_openForms(store) {
    const uid = store && store.user && store.user.id
    if (!uid) return []
    const list = (store.activeWORKSPACE && store.activeWORKSPACE.ALL_WIDGETS) || []
    return list.filter(w => w && w.record && w.record.segment === 'USER' && w.record.id === uid && !w.close && !w._softClosed && w.vueObj)   // замер dev: открытая форма — widget 'widget-record', widget_class 'widget_RECORD', record.segment 'USER' (widget_USER — лишь класс запроса открытия)
}

// замер dev (p242): executeWidgetMethod reload / select на форме «My profile» ломает её — вместо строк Email / Language на вкладке встаёт дерево настроек
// (Node / Title / Tooltip …), то есть путь ↻ записи для этой формы не годится; форма переоткрывается ТЕМ ЖЕ вызовом, что и пункт меню «My profile»
// (widget_open widget_USER, запись — пользователь): старая закрывается жёстко, новая встаёт на то же место стола / страницы с тем же styleWidget.
export function langProfile_reopen(store, w) {
    const uid = store.user && store.user.id
    const style = { ...(w.styleWidget || {}) }, workspace = w.workspace, page = w.page
    store.widget_close(w.id, false, true)
    return store.widget_open({ widget_class: 'widget_USER', workspace, page, styleWidget: style, record: { id: uid, title: store.user.title }, props: { id: uid } })
}

export function langProfile_refresh(store) {
    if (!langProfile_refreshOn(store)) return 0
    const forms = langProfile_openForms(store)
    for (const w of forms) langProfile_reopen(store, w)
    return forms.length
}

export function langProfile_errorText(answer) {
    if (!answer || typeof answer !== 'object') return t('no answer from the server')
    const m = answer.message || answer.error || (answer.notification && answer.notification.text) || ''
    return String(typeof m === 'string' ? m : JSON.stringify(m)).trim() || t('unknown error')
}

export function langProfile_warnText(answer) {
    return t('Language not saved to your profile: {error}. It will reset on the next reload.', { error: langProfile_errorText(answer) })
}
export function langProfile_readonlyText() {
    return t('Language not saved: read-only user. It will reset on the next reload.')
}

// колбэк user_settings_save: удача — перечитать профиль; иначе — уведомление (если флаг не выключен)
export function langProfile_saveDone(store, answer) {
    if (answer && typeof answer === 'object' && answer.status === 'ok') return langProfile_refresh(store)
    if (langProfile_warnOn(store)) store.show_notification({ header: '', text: langProfile_warnText(answer), status: 'error' })
    return -1
}
export function langProfile_readonlyWarn(store) {
    if (!langProfile_warnOn(store)) return false
    store.show_notification({ header: '', text: langProfile_readonlyText(), status: 'warning' })
    return true
}
